<script lang="ts" setup>
import type { SurfaceCollectionsMapValue } from '~/types/configurator'

const props = defineProps<{
  collection: SurfaceCollectionsMapValue
}>()

const surfacePropertiesKeys = [
  'composition',
  'fabricWeight',
  'fabricWidth',
  'frictionResistance',
  'colorResistanceLight',
  'colorResistanceFriction',
  'pilling',
  'fireResistance',
] as const

type ParametersKeys = Extract<
  keyof typeof props.collection,
  (typeof surfacePropertiesKeys)[number]
>

const surfaceProperties = computed(() => {
  const params = {} as Record<ParametersKeys, string>
  for (const key of surfacePropertiesKeys) {
    const value = props.collection[key]
    if (value && value !== '') {
      params[key] = value
    }
  }
  return params
})

const propertiesOpen = ref(false)
</script>

<template>
  <button
    v-if="Object.keys(surfaceProperties).length"
    class="flex w-full items-center justify-between p-5 hover:bg-neutral-100"
    :class="{
      'bg-neutral-100 hover:bg-neutral-200': propertiesOpen,
    }"
    @click="propertiesOpen = !propertiesOpen"
  >
    <p class="font-pragmatica-ext font-bold">
      {{ $t('configurator.properties') }} {{ props.collection.title }}
    </p>
    <Icon
      :name="propertiesOpen ? 'fa6-solid:arrow-up' : 'fa6-solid:arrow-down'"
    ></Icon>
  </button>
  <div v-if="propertiesOpen" class="grid grid-cols-1 gap-y-2 p-5">
    <template v-for="(property, index) in surfacePropertiesKeys">
      <div
        v-if="surfaceProperties[property]"
        :key="index"
        class="grid grid-cols-1 md:flex"
      >
        <span class="font-pragmatica-ext font-bold">
          {{ $t(`base.products.surfaces.parameters.${property}`) }}
        </span>
        <span class="flex-grow md:text-right">
          {{ surfaceProperties[property] }}
        </span>
      </div>
    </template>
  </div>
</template>
